import React from 'react';
import type { PageCode } from '@gov-nx/module/page';
import { useNastaveniKontaktnichUdajuROSItemContext } from '@gov-nx/module/page';
import { ContactEmailView } from '../ContactEmailView';
import { ContactPhoneView } from '../ContactPhoneView';
import { UsePersonalContactsDialog } from './UsePersonalContactsDialog';
import { useConfiguration } from '@gov-nx/core/service';
import { getRosContactDetailRedirectUrl } from '../../../../../../../utils/web/src/utils/getRosContactDetailRedirectUrl';

interface ROSContactViewProps {
	code: PageCode;
}

export const ROSContactView = ({ code }: ROSContactViewProps) => {
	const { contact, phone, email } =
		useNastaveniKontaktnichUdajuROSItemContext();
	const { citizenPortalEditRosInfoUrl } = useConfiguration();

	// ContactListView already filters with hasProperty('ico')
	if (!contact.ico) {
		return null;
	}

	const externalEditUrlWithParams = getRosContactDetailRedirectUrl({
		baseUrl: citizenPortalEditRosInfoUrl,
		ico: contact.ico,
		agendaCode: contact.agenda?.kod,
	});

	return (
		<>
			<h3 className="text-headline-s!">{contact.nazevSpolecnosti}</h3>

			<ContactEmailView
				code={code}
				externalEditUrl={externalEditUrlWithParams}
				{...email}
			/>

			<ContactPhoneView
				code={code}
				externalEditUrl={externalEditUrlWithParams}
				{...phone}
			/>

			{!citizenPortalEditRosInfoUrl && (
				<UsePersonalContactsDialog
					code={code}
					ico={contact.ico}
				/>
			)}
		</>
	);
};
